<template>
  <div>
    <div class="section">
      <h3 class="section-heading" v-if="!dws" v-html="$store.state.texts.dealer.title"></h3>
      <h3 class="section-heading" v-else v-html="$store.state.texts.dealer.titleDealer"></h3>
    </div>
    <!-- DEALER -->
    <div class="section dropdown" v-if="!dws">
      <div class="form-group required" aria-required="true">
          <label for="dealer" v-html="$store.state.texts.dealer.dealer.title"></label>
          <div class="custom-selectbox">
              <select name="dealer" id="dealer" v-model="$store.state.form.dealer" @change="$store.state.validation.dealer = true">
                  <option class="selected-value" selected="selected"  disabled="disabled" v-html="$store.state.texts.dealer.dealer.select"></option>
                  <option v-for="(dealer, index) in $store.state.dropdowns.dealers" :key="index" v-bind:value="dealer">{{ dealer.suggestedName }}</option>
              </select>
              <span class="selectedValue" v-if="$store.state.form.dealer === null" :class="{isInvalid: !$store.state.validation.dealer && $store.state.submitted}" v-html="$store.state.texts.dealer.dealer.select"></span>
              <span class="selectedValue" v-else :class="{isInvalid: !$store.state.validation.dealer && $store.state.submitted}">{{ $store.state.form.dealer.suggestedName }}</span>
              <span class="error-message" v-if="!$store.state.validation.dealer && $store.state.submitted" v-html="$store.state.texts.dealer.dealer.error"></span>
          </div>
      </div>
    </div>
    <!-- DEALER END -->

    <!-- DATE -->
    <div class="section datepicker">
      <div class="form-group required " aria-required="true">
          <label for="datepicker_887c" v-html="$store.state.texts.dealer.date.title"></label>
          <div id="datepicker"></div>
          <span
              class="error-message" :class="{'error': !$store.state.validation.date && $store.state.submitted}" v-if="!$store.state.validation.date && $store.state.submitted" v-html="$store.state.texts.dealer.date.error">
          </span>
      </div>
    </div>
    <!-- DATE END -->

    <!-- TIME -->
    <div class="section dropdown">
      <div class="form-group required" aria-required="true">
          <label for="title" v-html="$store.state.texts.dealer.time.title"></label>
          <div class="custom-selectbox">
              <select name="title" id="title" v-model="$store.state.form.appointment.time" @change="$store.state.validation.time = true">
                  <option class="selected-value" selected="selected"  disabled="disabled" v-html="$store.state.texts.dealer.time.select"></option>
                  <option v-for="(time, index) in $store.state.dropdowns.times" :key="index">{{ time }}</option>
              </select>
              <span class="selectedValue" v-if="$store.state.form.appointment.time === ''" :class="{isInvalid: !$store.state.validation.time && $store.state.submitted}" v-html="$store.state.texts.dealer.time.select"></span>
              <span class="selectedValue" v-else :class="{isInvalid: !$store.state.validation.time && $store.state.submitted}">{{ $store.state.form.appointment.time }}</span>
              <span class="error-message" v-if="!$store.state.validation.time && $store.state.submitted" v-html="$store.state.texts.dealer.time.error"></span>
          </div>
          <span class="help-block">
            <p v-html="$store.state.texts.dealer.time.helpText"></p>
          </span>
      </div>
    </div>
    <!-- TIME END -->
  </div>
</template>

<script>
import $ from 'jquery'
import datepickerFactory from 'jquery-datepicker'

datepickerFactory($)

export default {
  name: 'Dealer',
  data () {
    return {
      dws: false
    }
  },
  created () {
    if (this.$route.query.dws) {
      this.dws = true
      this.$store.state.validation.dealer = true
      this.$store.state.form.dealer = {
        dealerId: this.$route.query.dws
      }
    }
  },
  mounted () {
    $('#datepicker').datepicker({
      minDate: 1,
      maxDate: 90,
      beforeShowDay: $.datepicker.noWeekends,
      firstDay: 1,
      nextText: '',
      prevText: '',
      setDate: null,
      monthNames: this.$store.state.dropdowns.monthsLong,
      monthNamesShort: this.$store.state.dropdowns.monthsShort,
      dayNamesMin: this.$store.state.dropdowns.dateNamesMin,
      dayNamesShort: this.$store.state.dropdowns.dateNamesShort,
      dayNames: this.$store.state.dropdowns.dateNamesLong,
      onSelect: (date) => {
        this.$store.state.form.appointment.date = date
        this.$store.state.validation.date = true
      }
    })
  },
  methods: {
    fieldValidations (validation, storeObj) {
      if (validation === false) {
        this.$store.state.validation[storeObj] = true
      } else {
        this.$store.state.validation[storeObj] = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  //ERROR HANDLING
  .isInvalid {
    border: 2px solid red!important;
  }
  input.isInvalid::placeholder {
    color: red;
  }
  .error-message {
    display: block;
    color: red;
  }
  .c_019 .form-group .custom-selectbox {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/form/Dealer.vue